import React from "react";
import Wrapper from "../Components/Wrapper";
import Herosection from "../Components/Herosection";
import { Accordion, Col, Container, Row } from "react-bootstrap";
import faq from "../assets/images/faq-1.jpg";

function Faq() {
  return (
    <Wrapper>
      <Herosection title={"FAQ"} />
      <Container>
        <Row className="py-5">
          <Col lg={7} data-aos="fade-right">
            <div className="faq-data">
              <p className="fw-bold">Our FAQ</p>
              <h2 className="fw-bold py-2">Frequently Asked Questions?</h2>
              <div className="faq-accordian">
                <Accordion defaultActiveKey="0" alwaysOpen>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>What is BCA Study?</Accordion.Header>
                    <Accordion.Body>
                      BCA Study is a free online platform providing
                      comprehensive study materials for Bachelor of Computer
                      Applications (BCA) students.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>Who can use BCA Study?</Accordion.Header>
                    <Accordion.Body>
                      BCA Study is designed for BCA students, but anyone
                      interested in learning about computer applications can
                      benefit from our resources.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      Are the study materials really free?
                    </Accordion.Header>
                    <Accordion.Body>
                      Yes, all our study materials are completely free to
                      access.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="3">
                    <Accordion.Header>
                      Can I download the study materials?
                    </Accordion.Header>
                    <Accordion.Body>
                      Yes, most of our study materials are available for
                      download so you can access them offline.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="4">
                    <Accordion.Header>
                      Do I need to create an account to access the resources?
                    </Accordion.Header>
                    <Accordion.Body>
                      No, you do not need an account to access our free
                      resources.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="5">
                    <Accordion.Header>
                      How can I provide feedback or suggest new content?
                    </Accordion.Header>
                    <Accordion.Body>
                      We welcome feedback and suggestions! Please use our
                      contact form or email us directly at
                      feedback@bcastudy.com.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="6">
                    <Accordion.Header>
                      How can I support BCA Study?
                    </Accordion.Header>
                    <Accordion.Body>
                      You can support us by sharing our website with your peers,
                      providing feedback, and considering a donation if you find
                      our resources helpful.
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>
          </Col>
          <Col lg={5} className="py-5" data-aos="fade-left">
            <div className="overflow-hidden ratio-1x1 rati rounded-4">
              <img className="img-fluid" src={faq} alt="" />
            </div>
          </Col>
        </Row>
      </Container>
    </Wrapper>
  );
}

export default Faq;
